import React from 'react'
import VideoRecommendationCard from '@/components/VideoRecommendationCard'
import { YoutubeVideoDetails } from '@/store/types'
import { useTranslation } from 'react-i18next'

type VideoRecommendationSectionProps = {
	title: string
	videos: YoutubeVideoDetails[]
}

const VideoRecommendationSection: React.FC<VideoRecommendationSectionProps> = ({ title, videos }) => {
	const { t } = useTranslation()
	const flag = import.meta.env.VITE_LOCALIZATION_ENABLED
	const isEnabled = Boolean(flag) && flag !== 'false'

	// When i18n is enabled, try to translate the title; fall back to the raw string if no key found.
	const displayTitle = isEnabled ? t(title, { defaultValue: title }) : title

	return (
		<div className='mb-6'>
			<h2 className='text-lg font-semibold mb-2 text-white'>{displayTitle}</h2>
			<div className='flex pb-4 w-full overflow-x-auto overflow-y-hidden whitespace-nowrap gap-2'>
				{videos.map((video) => <VideoRecommendationCard key={video.title} {...video} />)}
			</div>
		</div>
	)
}

export default VideoRecommendationSection
